mutation CopyChatOverlayToEvent($eventId: ID!, $fromChatId: ID!, $fromEventId: ID, $channels: String!) {
  chat: StreamToolsCopyChatOverlayToEvent(eventId: $eventId, fromChatId: $fromChatId, fromEventId: $fromEventId, channels: $channels) {
    chatId
    eventId
    name
    twitchChatChannels
    showTextShadow
    textShadow
    showBadges
    showChannelPills
    usernameFontSize
    usernameLineHeight
    messageFontSize
    messageLineHeight
    messageFontWeight
    usernameFontWeight
    imageScale
    messageColor
    blockedWords
    fontFamily
    youtubeSourceEnabled
    youtubeChatChannels
    chatDelayMs
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    showYouTubeProfilePictures
    createdAt
  }
}
